import api from "PFCore/api";
import { Id } from "PFCore/types";
import { ChatParticipant } from "PFTypes/chat_participant";

export type FetchParticipantsPayload = {
  conversationId: Id;
  profileId?: Id;
  withMessage?: boolean;
  conversationOpen?: boolean;
  interlocutorProfileId?: Id;
  target?: { id: Id; type: string };
  page?: number;
  perPage?: number;
};

type FetchParticipantsResponse = {
  entries: ChatParticipant[];
  meta: { total: number };
};

export const fetchParticipants = ({
  conversationId,
  withMessage = false,
  conversationOpen,
  interlocutorProfileId,
  target,
  profileId,
  page = 1,
  perPage = 50
}: FetchParticipantsPayload): Promise<FetchParticipantsResponse> =>
  api({
    url: "chat/participants",
    params: {
      conversationId,
      withMessage,
      conversationOpen,
      interlocutorProfileId,
      target,
      profileId,
      page,
      perPage
    }
  });
